module.exports = __webpack_public_path__ + "static/club_artisee-5b364388379bc21d441d48a6a33b7b22.jpg";